import { gsap } from 'gsap';
$(document).on('click', '.products-detail-trigger', function () {
  let $this = $(this);
  let $target = $this.next();

  // 各要素ごとに個別のタイムラインとフラグを作成
  if (!$this.data('pFlag')) {
    $this.data('pFlag', false); // 初期値を false に設定
  }

  // 個別のタイムラインを生成
  let TL = gsap.timeline();

  if ($this.data('pFlag') == false) {
    TL.to($this, { scale: 0, ease: "power2.in", duration: 0.3 })
      .to($target, { scale: 1, ease: "power2.out", duration: 0.3 });

    $this.data('pFlag', true);  // フラグを更新
  }
  return false;
});

$(document).on('click', '.products-detail-closer', function () {
  let $this = $(this).parent();
  let $target = $this.prev();

  // 閉じるアクションにも個別のフラグを利用
  if (!$target.data('pFlag')) {
    $target.data('pFlag', false); // 初期値を false に設定
  }

  // 個別のタイムラインを生成
  let TL = gsap.timeline();

  if ($target.data('pFlag') == true) {
    TL.to($this, { scale: 0, ease: "power2.in", duration: 0.3 })
      .to($target, { scale: 1, ease: "power2.out", duration: 0.3 });

    $target.data('pFlag', false);  // フラグをリセット
  }
  return false;
});
